import { useContext } from "react";
import { useIsUserCredOwner } from "./useIsUserCredOwner";
import { ICredential } from "../types/credential";
import UserContext from "../../../contexts/UserContext";

interface IUseShouldDisableSaveParams {
  credentialParam?: ICredential | undefined;
}

const useShouldDisableSave = ({ credentialParam }: IUseShouldDisableSaveParams) => {
  const isUserCredOwner = useIsUserCredOwner({ credentialParam });
  const userModel = useContext(UserContext);

  return !isUserCredOwner && !userModel.isCredAdmin();
}

export default useShouldDisableSave;
